import { render, staticRenderFns } from "./AMapLoader.vue?vue&type=template&id=4442202b&scoped=true&"
import script from "./AMapLoader.vue?vue&type=script&lang=js&"
export * from "./AMapLoader.vue?vue&type=script&lang=js&"
import style0 from "./AMapLoader.vue?vue&type=style&index=0&id=4442202b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4442202b",
  null
  
)

export default component.exports